if (!customElements.get('font-eula-consent')) {
  customElements.define(
    'font-eula-consent',
    class FontEulaConsent extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.error = this.querySelector('[data-error]');
        if (!this.checkbox) return;

        // Capture phase at document level runs before the theme's own form/button handlers
        this.guard = this.guard.bind(this);
        document.addEventListener('submit', this.guard, true);
        document.addEventListener('click', this.guard, true);

        // "I agree" inside the EULA modal (moved to <body> by the theme's modal-dialog)
        this.onAccept = (event) => {
          const button = event.target instanceof Element && event.target.closest('[data-eula-accept]');
          if (!button) return;
          this.checkbox.checked = true;
          this.linkToForm();
          this.toggleError(false);
          button.closest('modal-dialog')?.hide();
          this.checkbox.focus({ preventScroll: true });
        };
        document.addEventListener('click', this.onAccept);

        this.checkbox.addEventListener('change', () => {
          this.linkToForm();
          if (this.checkbox.checked) this.toggleError(false);
        });
        this.linkToForm();
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.guard, true);
        document.removeEventListener('click', this.guard, true);
        document.removeEventListener('click', this.onAccept);
      }

      get container() {
        return this.closest('.product__info-container') || this.closest('section') || document;
      }

      get form() {
        return this.container.querySelector('form[data-type="add-to-cart-form"]');
      }

      // Associate the checkbox with the product form so its value is sent as a line item property.
      // Looked up each time because the theme re-renders parts of the product form on variant change.
      linkToForm() {
        // getAttribute, not form.id: the product form has an <input name="id"> that shadows the property
        const formId = this.form?.getAttribute('id');
        if (formId) this.checkbox.setAttribute('form', formId);
      }

      guard(event) {
        const target = event.target;
        if (!(target instanceof Element) || !this.container.contains(target)) return;

        const isAddToCart = event.type === 'submit' && target.matches('form[data-type="add-to-cart-form"]');
        const isBuyButton = event.type === 'click' && target.closest('.product-form__buttons');
        if (!isAddToCart && !isBuyButton) return;

        this.linkToForm();
        if (this.checkbox.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.toggleError(true);
      }

      toggleError(show) {
        this.classList.toggle('is-invalid', show);
        if (this.error) this.error.hidden = !show;
        this.checkbox.setAttribute('aria-invalid', show);
        if (show) {
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.checkbox.focus({ preventScroll: true });
        }
      }
    }
  );
}
